var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgO04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.1,50L17.6,98.7C7,84.7,1.1,67.6,1,50C1.1,32.4,7,15.3,17.6,1.3L98.1,50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,100l-0.6-0.8C6,85.1,0.1,67.8,0,50C0.1,32.2,6,14.9,16.8,0.8L17.4,0L100,50L17.4,100z M17.9,2.6 C7.7,16.3,2.1,32.9,2.1,50c0.1,17.1,5.6,33.7,15.8,47.3l78.3-47.4L17.9,2.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO04);
export default __webpack_public_path__ + "static/media/O_04.6b65551ba86a1e221ff0026689fb8152.svg";
export { ForwardRef as ReactComponent };